<template>
  <section
    :style="{ backgroundColor: data.background_color }"
    :class="{ 'has-two-columns': hasTwoColumns }"
    class="wrapper-module-component">
    <div class="wrapper-module-component__columns">
      <slot />
    </div>

    <svg
      class="wrapper-module-component__decoration"
      xmlns="http://www.w3.org/2000/svg"
      width="876"
      height="1573"
      viewBox="0 0 876 1573"
      fill="none">
      <g opacity="0.3">
        <path
          d="M1115.43 622.028L686.631 922.64C678.135 928.708 666.691 928.708 658.022 922.64L498.848 811.688C477.348 796.778 448.738 796.778 427.411 811.688L229.918 950.205L658.195 1250.47C666.865 1256.54 678.309 1256.54 686.805 1250.47L1283.27 832.145C1316.56 808.741 1336.5 770.601 1336.5 729.86V507.088C1336.5 470.508 1318.64 436.009 1288.65 415.032L736.742 28.9517C698.075 1.90704 646.405 1.90704 607.738 28.9517L56.5257 415.726C26.5289 436.703 8.66959 471.029 8.66959 507.782V684.786C8.66959 723.792 52.7111 746.85 84.7886 724.313L658.022 322.109C666.691 316.042 678.135 316.042 686.631 322.109L1115.26 622.201L1115.43 622.028Z"
          stroke="#13D377"
          stroke-miterlimit="10" />
        <path
          d="M658.022 1250.64L229.744 950.378L658.022 649.419C666.691 643.352 677.962 643.352 686.631 649.419L853.434 765.573C870.6 777.535 893.488 777.535 910.654 765.573L1115.43 622.028L686.805 321.936C678.135 315.868 666.691 315.868 658.195 321.936L61.9009 740.262C28.6096 763.666 8.66959 801.806 8.66959 842.546V1064.97C8.66959 1101.55 26.5289 1135.88 56.5257 1156.85L607.738 1543.63C646.405 1570.85 698.075 1570.85 736.742 1543.63L1288.47 1156.68C1318.47 1135.7 1336.33 1101.38 1336.33 1064.62V887.621C1336.33 848.441 1292.29 825.557 1260.21 848.094L686.458 1250.47C677.788 1256.54 666.345 1256.54 657.848 1250.47L658.022 1250.64Z"
          stroke="#13D377"
          stroke-miterlimit="10" />
      </g>
    </svg>
  </section>
</template>

<script setup>
import { computed } from 'vue'

/* #META
 {
  "NAME": "WrapperComponent",
  "CLASSNAME": "wrapper-module-component",
  "URL": "http://vuevitewp.local/test"
 }
#ENDMETA */

const props = defineProps(['data'])

const getAcfField = (source, snakeKey, camelKey) => {
  return source?.[snakeKey] ?? source?.[camelKey]
}

const isAcfEnabled = (value) => {
  return value === true || value === 1 || value === '1'
}

const hasTwoColumns = computed(() => {
  const rightColumn = getAcfField(props.data, 'right_column', 'rightColumn')

  return (
    isAcfEnabled(getAcfField(props.data, 'add_column', 'addColumn')) &&
    Array.isArray(rightColumn) &&
    rightColumn.length > 0
  )
})
</script>

<style lang="scss" scoped>
.wrapper-module-component {
  width: 100%;
  position: relative;
  overflow: hidden;
  @apply pt-3 xl:pb-[80px] md:px-10 xl:px-0;

  &__columns {
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    width: 100%;
    position: relative;
    z-index: 1;
  }

  &__decoration {
    display: none;
  }

  @media (min-width: 1024px) {
    &__decoration {
      position: absolute;
      right: 0;
      top: 200px;
      display: block;
      pointer-events: none;
      z-index: 0;
    }
  }

  &.has-two-columns {
    @media (min-width: 1280px) {
      .wrapper-module-component__columns {
        @apply flex flex-row gap-[100px] pl-[100px] mx-auto max-w-[1282px];

        :deep(.wrapper-module-component__column--left) {
          width: 743px;
          flex: 0 0 743px;
        }
      }
    }
  }

  :deep(.wrapper-module-component__column) {
    display: flex;
    flex-direction: column;
    min-width: 0;
  }

  :deep(.wrapper-module-component__column-item) {
    display: flex;
    flex-direction: column;
    min-width: 0;
  }

  @media (max-width: 767px) {
    :deep(.wrapper-module-component__column-item.hide-on-mobile) {
      display: none;
    }
  }

  @media (min-width: 768px) and (max-width: 1023px) {
    :deep(.wrapper-module-component__column-item.hide-on-tablet) {
      display: none;
    }
  }

  @media (min-width: 1024px) {
    :deep(.wrapper-module-component__column-item.hide-on-desktop) {
      display: none;
    }
  }
}
</style>
